import React from 'react'
import { connect } from 'react-redux'
import Sidebar from '../components/Sidebar'
import { toggleDocked, initDocked } from '../store/actions'

export default function(SidebarContentComponent, sidebarAction, sidebarState) {
  class SidebarContainer extends React.Component {
    componentDidMount() {
      this.props.dispatch(initDocked(sidebarAction, this.props.showByDefault))
    }

    toggleDocked = () => {
      this.props.dispatch(toggleDocked(sidebarAction))
    }
    render() {
      return (
        <Sidebar key={sidebarState + '-sidebar'} {...this.props} toggleDocked={this.toggleDocked}>
          <SidebarContentComponent />
        </Sidebar>
      )
    }
  }

  function mapStateToProps(state, ownProps) {
    return {
      docked: state[sidebarState].docked,
      ...ownProps,
    }
  }

  return connect(mapStateToProps)(SidebarContainer)
}
